function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["disabled", "fontIconProps", "iconButtonProps", "initial", "labels", "loading", "locale", "onPageChange", "total"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { DEFAULT_ISO_LANGUAGE_REGION } from '@brandfolder/utilities';
import classnames from 'classnames';
import React, { useState, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { useBreakpoints } from "../../../../hooks/use-breakpoints.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import { useRtl } from "../../../../hooks/use-rtl.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import { FontIcon } from "../../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import { IconButton } from "../../../atoms/button/icon-button/icon-button.js";
import "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var getPagesArray = function getPagesArray(fromPage, toPage) {
  if (toPage === 1) {
    return [];
  }
  var length = (toPage - fromPage) / 1;
  return Array.from({
    length: length
  }, function (_, i) {
    return fromPage + i;
  });
};
var UnstyledPagination = function UnstyledPagination(props) {
  var disabled = props.disabled,
    fontIconProps = props.fontIconProps,
    iconButtonProps = props.iconButtonProps,
    _props$initial = props.initial,
    initial = _props$initial === void 0 ? 1 : _props$initial,
    _props$labels = props.labels,
    labels = _props$labels === void 0 ? {
      nextLabel: '',
      previousLabel: ''
    } : _props$labels,
    loading = props.loading,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? DEFAULT_ISO_LANGUAGE_REGION : _props$locale,
    onPageChange = props.onPageChange,
    total = props.total,
    otherProps = _objectWithoutProperties(props, _excluded);
  var nextLabel = labels.nextLabel,
    previousLabel = labels.previousLabel;
  var _useBreakpoints = useBreakpoints(),
    isMd = _useBreakpoints.isMd,
    isSm = _useBreakpoints.isSm,
    isXSm = _useBreakpoints.isXSm,
    isXxSm = _useBreakpoints.isXxSm;
  var _useRtl = useRtl(),
    isRtl = _useRtl.isRtl;
  var _useState = useState(initial),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var _useState3 = useState(FontIcons.CaretRight),
    _useState4 = _slicedToArray(_useState3, 2),
    iconNext = _useState4[0],
    setIconNext = _useState4[1];
  var _useState5 = useState(FontIcons.CaretLeft),
    _useState6 = _slicedToArray(_useState5, 2),
    iconPrevious = _useState6[0],
    setIconPrevious = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    morePrevious = _useState8[0],
    setMorePrevious = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    moreNext = _useState10[0],
    setMoreNext = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    pages = _useState12[0],
    setPages = _useState12[1];
  var _useState13 = useState(1),
    _useState14 = _slicedToArray(_useState13, 2),
    siblings = _useState14[0],
    setSiblings = _useState14[1];
  var isCurrentFirst = current === 1;
  var isCurrentLast = current === total;
  var isDisabled = disabled || loading;
  var getPages = function getPages() {
    // start at 2 because we always show page 1
    var fromPage = 2;
    // number of first and last buttons
    var boundaries = 1;
    // first and last buttons totalled
    var totalBoundaries = boundaries * 2;
    // siblings (both on left side and right side of current) totalled
    var totalSiblings = siblings * 2;
    var totalBoundariesAndSiblings = totalBoundaries + totalSiblings + 2;
    if (totalBoundariesAndSiblings >= total) {
      setMorePrevious(false);
      setMoreNext(false);
      return getPagesArray(fromPage, total);
    }
    var leftSiblingIndex = Math.max(current - siblings, boundaries);
    var rightSiblingIndex = Math.min(current + siblings, total - boundaries);
    var showMorePrevious = leftSiblingIndex >= boundaries + 2;
    var showMoreNext = rightSiblingIndex <= total - (boundaries + 1);
    setMorePrevious(showMorePrevious);
    setMoreNext(showMoreNext);
    if (!showMorePrevious && showMoreNext) {
      var leftItemCount = totalSiblings + boundaries + 2;
      return getPagesArray(fromPage, leftItemCount);
    }
    if (showMorePrevious && !showMoreNext) {
      var rightItemCount = boundaries + 1 + totalSiblings;
      var _fromPage = total - rightItemCount + 1;
      return getPagesArray(_fromPage, total);
    }
    return getPagesArray(leftSiblingIndex, rightSiblingIndex + 1);
  };
  useEffect(function () {
    setCurrent(initial);
  }, [initial]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    setPages(getPages());
  }, [current, locale, siblings, total]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (isMd) {
      setSiblings(4);
    } else if (isSm) {
      setSiblings(3);
    } else if (isXSm) {
      setSiblings(2);
    } else {
      setSiblings(1);
    }
  }, [isXxSm, isXSm, isSm, isMd]);
  useEffect(function () {
    if (isRtl) {
      setIconNext(FontIcons.CaretLeft);
      setIconPrevious(FontIcons.CaretRight);
    } else {
      setIconNext(FontIcons.CaretRight);
      setIconPrevious(FontIcons.CaretLeft);
    }
  }, [isRtl]);
  var onPage = function onPage(page) {
    setCurrent(page);
    onPageChange(page);
  };
  var renderNextPrevious = function renderNextPrevious(type) {
    var _classnames;
    var disablePrevious = type === 'previous' && isCurrentFirst;
    var disableNext = type === 'next' && isCurrentLast;
    var disableNextPrevious = isDisabled || disableNext || disablePrevious;
    var icon = type === 'next' ? iconNext : iconPrevious;
    var label = type === 'next' ? nextLabel : previousLabel;
    var page = type === 'next' ? current + 1 : current - 1;
    return /*#__PURE__*/React.createElement(IconButton, _extends({}, iconButtonProps, {
      className: classnames((_classnames = {}, _defineProperty(_classnames, "bf-pagination__".concat(type), true), _defineProperty(_classnames, "bf-pagination__".concat(type, "--disabled"), disableNextPrevious), _defineProperty(_classnames, "".concat(iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.className), !!(iconButtonProps !== null && iconButtonProps !== void 0 && iconButtonProps.className)), _classnames)),
      disabled: disableNextPrevious,
      icon: icon,
      label: label,
      look: ButtonLooks.Default,
      onClick: disableNextPrevious ? undefined : function () {
        return onPage(page);
      },
      onKeyUp: function onKeyUp(e) {
        if (e.key === 'Enter' && !disableNextPrevious) {
          onPage(page);
        }
      }
    }));
  };
  var renderPage = function renderPage(page) {
    var isCurrentPage = current === page;
    var isFirst = page === 1;
    var isLast = page === total;
    var look = isCurrentPage ? ButtonLooks.Primary : ButtonLooks.Tertiary;
    var pageLocalized = page.toLocaleString(locale);
    return /*#__PURE__*/React.createElement(IconButton, _extends({}, iconButtonProps, {
      "aria-current": isCurrentPage || undefined,
      className: classnames(_defineProperty({
        'bf-pagination__page': true,
        'bf-pagination__page--current': isCurrentPage,
        'bf-pagination__page--disabled': isDisabled,
        'bf-pagination__page--first': isFirst,
        'bf-pagination__page--last': isLast
      }, "".concat(iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.className), !!(iconButtonProps !== null && iconButtonProps !== void 0 && iconButtonProps.className))),
      disabled: isDisabled,
      key: page,
      label: pageLocalized,
      look: look,
      onClick: !isCurrentPage && !isDisabled ? function () {
        return onPage(page);
      } : undefined,
      onKeyUp: function onKeyUp(e) {
        if (e.key === 'Enter' && !isCurrentPage && !isDisabled) {
          onPage(page);
        }
      }
    }), pageLocalized);
  };
  var renderPages = function renderPages() {
    return pages.map(function (page) {
      return renderPage(page);
    });
  };
  var renderFirst = function renderFirst() {
    return renderPage(1);
  };
  var renderLast = function renderLast() {
    return total > 1 ? renderPage(total) : null;
  };
  var renderMore = function renderMore() {
    return /*#__PURE__*/React.createElement(FontIcon, _extends({}, fontIconProps, {
      "aria-hidden": true,
      className: classnames(_defineProperty({
        'bf-pagination__more': true
      }, "".concat(fontIconProps === null || fontIconProps === void 0 ? void 0 : fontIconProps.className), !!(fontIconProps !== null && fontIconProps !== void 0 && fontIconProps.className))),
      icon: FontIcons.Ellipsis
    }));
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: classnames(_defineProperty({
      'bf-pagination': true,
      'bf-pagination__standard': true,
      'bf-pagination__standard--disabled': disabled
    }, "".concat(otherProps === null || otherProps === void 0 ? void 0 : otherProps.className), !!(otherProps !== null && otherProps !== void 0 && otherProps.className)))
  }), renderNextPrevious('previous'), renderFirst(), morePrevious && renderMore(), renderPages(), moreNext && renderMore(), renderLast(), renderNextPrevious('next'));
};
var StyledPagination = styled(UnstyledPagination)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  .bf-button__icon {\n    border-radius: 2px;\n    font-size: 14px;\n    height: 32px;\n    margin: 3px;\n    min-height: 0;\n    min-width: 32px;\n    padding-left: 7px;\n    padding-right: 7px;\n  }\n\n  .bf-button__font-icon {\n    font-size: 12px;\n  }\n\n  .bf-pagination__more {\n    align-items: center;\n    color: ", ";\n    display: flex;\n    height: 32px;\n    justify-content: center;\n    margin: 3px;\n    width: 32px;\n  }\n\n  .bf-pagination__page {\n    font-variant-numeric: tabular-nums;\n  }\n\n  .bf-pagination__page--current {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    cursor: default;\n\n    &[aria-disabled='true'] {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.text.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.button.primary.backgroundColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.button.primary.borderColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.button.primary.textColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.button.primary.backgroundColorDisabled;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.button.primary.borderColorDisabled;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.button.primary.textColorDisabled;
});
/**
 * Pagination allows a user to move between pages of content such as search results.
 * Note that this pagination component uses `<button>` tags (it does not use `<a>` tags to change the URL).
 *
 * https://developer.mozilla.org/en-US/docs/Web/CSS/Layout_cookbook/Pagination
 *
 *
 * @param props StandardPaginationProps
 * @returns FunctionComponent<StandardPaginationProps>
 */
var StandardPagination = function StandardPagination(props) {
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(StyledPagination, _extends({}, props)));
};
export { StandardPagination };